import Quill, { Delta } from 'quill';
import { useEffect, useRef } from 'react'
import "quill/dist/quill.snow.css";

const COLORS = [
  "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
  "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
  "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
  "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
  "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"
]

interface BasicRichTextEditorProps {
  defaultValue?: Delta
  onChange?: (changes: Delta) => void
}

const fontSizes = Array.from({length: 25})
  .map((_, index) => (index +5))
  .filter(item => item %2 === 0)
  .map(item => `${item}px`)

const Size = Quill.import('attributors/style/size') as any;
Size.whitelist = fontSizes;
Quill.register(Size, true);

const Parchment = Quill.import('parchment');
const config = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['0.4', '0.6', '0.8', '1.0', '1.2', '1.5', '2.0']
}
var lineHtClass = new Parchment.Attributor.Class('line-height','ql-line-height', config);
var lineHtStyle = new Parchment.Attributor.Style('line-height','line-height', config);

Parchment.register(lineHtClass);
Parchment.register(lineHtStyle);


export const BasicRichTextEditor = (props:BasicRichTextEditorProps ) => {
  const {defaultValue, onChange} = props
  const ref = useRef<HTMLDivElement>(null)
  const editRef = useRef<any>(null)
  const onChangeRef = useRef<any>(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    if (!ref.current) return;
    if (editRef.current) return;

    const quill = new Quill(ref.current, {
      modules: {
        toolbar: '#toolbar'
      },
      placeholder: 'Input text',
      theme: 'snow',
    });
    if (defaultValue) quill.setContents(defaultValue)
    editRef.current = quill
    quill.on('text-change', (delta, oldDelta, source) => {
      if(onChangeRef.current) onChangeRef.current(quill.getContents())
    })
  }, [])

  useEffect(() => {
    editRef.current?.setContents(defaultValue)
  }, [])

  return <>
    <div id="toolbar">

      <select className="ql-size">
        {fontSizes.map(item => {
          return <option value={item} selected={item === '14px'}>{item}</option>
        })}
      </select>
      <select className="ql-line-height">
        <option value="0.4"></option>
        <option value="0.6"></option>
        <option value="0.8"></option>
        <option value="1.0"></option>
        <option value="1.2" selected></option>
        <option value="1.5"></option>
        <option value="2.0"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <button className="ql-strike"></button>
      <select className="ql-color">
        {COLORS.map(item => {
          return <option value={item}>{item}</option>
        })}
      </select>
    </div>
    <div ref={ref}></div>
  </>
}